
import { Button } from "@/components/ui/button";
import { MessageCircle, Instagram, Mail, Phone } from "lucide-react";

export const TelegramSection = () => {
  return (
    <div className="text-center space-y-6">
      <h2 className="text-2xl font-bold mb-2 text-foreground">Connect with Us</h2>
      <p className="text-muted-foreground mb-6">
        Multiple ways to reach bytehype
      </p>
      <div className="space-y-4">
        <Button
          onClick={() => window.open('https://t.me/bytehype', '_blank')}
          className="bg-foreground hover:bg-foreground/90 text-background gap-2 w-full"
        >
          <MessageCircle className="h-5 w-5" />
          Open Telegram Chat
        </Button>
        
        <Button
          onClick={() => window.open('https://wa.me/0408278623', '_blank')}
          className="bg-foreground hover:bg-foreground/90 text-background gap-2 w-full"
        >
          <Phone className="h-5 w-5" />
          WhatsApp: 0408278623
        </Button>
        
        <Button
          onClick={() => window.open('mailto:hello@bytehype.com.au', '_blank')}
          className="bg-foreground hover:bg-foreground/90 text-background gap-2 w-full"
        >
          <Mail className="h-5 w-5" />
          Email: hello@bytehype.com.au
        </Button>
        
        <Button
          onClick={() => window.open('https://instagram.com/heybytehype', '_blank')}
          className="bg-foreground hover:bg-foreground/90 text-background gap-2 w-full"
        >
          <Instagram className="h-5 w-5" />
          Instagram: @heybytehype
        </Button>
        
        <div>
          <a 
            href="https://bytehype.com.au/contact" 
            className="text-muted-foreground hover:text-foreground transition-colors text-sm underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Back to Base
          </a>
        </div>
      </div>
    </div>
  );
};
